export class Company {
  name: string;
  address: string;
  city: string;
  country: string;
  website: string;
  phoneNumber: string;
  taxOffice: string;
  taxNumber: string;
}
